const UNIT_LABELS_BY_UCUM_CODE = new Map<string, string>([
  ['Cel', '°C'],
  ['[degF]', '°F'],
  ['degF', '°F'],
  ['[lb_av]', 'lb'],
  ['[oz_av]', 'oz'],
  ['[in_i]', 'in'],
  ['[in_us]', 'in'],
  ['[ft_i]', 'ft'],
  ['mm[Hg]', 'mmHg'],
  ['kg/m2', 'kg/m²'],
]);

export function unitLabel(unit: string): string;
export function unitLabel(unit: string | undefined): string | undefined;
export function unitLabel(unit: string | undefined): string | undefined {
  return (unit && UNIT_LABELS_BY_UCUM_CODE.get(unit)) || unit;
}
